import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getBrowserLang, TranslocoService } from '@ngneat/transloco';

import {
  ANALYTICS_APP_NAMES_ENUM,
  GoogleAnalyticsService,
} from './services/analytics.service';
import { MatIconRegistry } from '@angular/material/icon';
import { AnnouncementService } from './services/announcement.service';

@Component({
  selector: 'angular-community-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'The Angular Community Meetup';
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private router: Router,
    private metaTagService: Meta,
    private titleService: Title,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private gaService: GoogleAnalyticsService,
    private translocoService: TranslocoService,
    private announcementService: AnnouncementService
  ) {
    this.matIconRegistry.addSvgIcon(
      'twitter',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/svgs/twitter.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'linkedin',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/svgs/linkedin.svg'
      )
    );

    this.getUserLang();

    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.gaService.createFAScreenView(
            ANALYTICS_APP_NAMES_ENUM.meetup,
            event.urlAfterRedirects
          );
        }
      });
    this.metaTagService.addTags([
      {
        name: 'description',
        content:
          'Angular Community Meetup is a monthly, multi-event organization whose mission is to build a stronger and more connected Angular Community across the world.',
      },
      {
        name: 'keywords',
        content:
          'Angular Community, meetup, Angular, Talks, Organizer, Erik Slack, event, ng-conf',
      },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Erik Slack' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'date', content: '2021-05-14', scheme: 'YYYY-MM-DD' },
      { charset: 'UTF-8' },
    ]);
    this.titleService.setTitle('Angular Community Meetup');
  }

  ngOnInit() {
    this.announcementService.showActiveAnnouncement();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getUserLang(): void {
    const translocoLanguages =
      this.translocoService.getAvailableLangs() as string[];
    const isLangAvailable = translocoLanguages.find(
      (lang) => lang == getBrowserLang()
    );

    if (isLangAvailable) {
      this.translocoService.setActiveLang(isLangAvailable);
    } else {
      this.translocoService.setActiveLang('en');
    }
  }
}
